import _AirPlayButton from "./components/AirPlayButton";
import _enableAirPlay from "./enableAirPlay";
var exports = {};
var createAirPlayButton = _AirPlayButton,
  createAirPlayPlugin = _enableAirPlay;

/**
 * @module index
 */

/**
 * Registers the AirPlay plugin and AirPlayButton Component with Video.js. See
 * {@link module:AirPlayButton} and {@link module:enableAirPlay} for more details about
 * how the plugin and button are registered and configured.
 *
 * @param {object} videojs
 * @see module:enableAirPlay
 * @see module:AirPlayButton
 */
exports = function (videojs) {
  videojs = videojs || window.videojs;
  createAirPlayButton(videojs);
  createAirPlayPlugin(videojs);
};
export default exports;